import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38135bee"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 참여유형을 선택해주세요! ", -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["value", "data-checked"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio" }, null, -1))

import CampaignCheck, { Expose as CampaignCheckExpose } from '@/components/campaign/check.vue';
import CampaignQuiz, { Expose as CampaignQuizExpose } from '@/components/campaign/quiz.vue';
import CampaignParticipate, { Expose as CampaignParticipateExpose } from '@/components/campaign/participate.vue';
import { IProgram } from '@/types/program';
import { ref, reactive, inject, nextTick, computed } from 'vue';
import { ColorVariants } from '@/constants';
import _ from 'lodash';
import dayjs from 'dayjs';
import './dialog.scss';

interface Props {
  program: IProgram;
}
interface Info {
  title: string;
  content: string;
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
  program: IProgram;
}



const collectionChallenge = ref('30');
const radioOptions = [
  {
    value: '30',
    label: '30개 챌린지'
  },
  {
    value: '100',
    label: '100개 챌린지'
  }
];

const dialog = reactive({
  info: false,
  participate: false,
});

const infoDialogProps = ref<Info>();
function showInfoDialog(info: Info) {
  infoDialogProps.value = info;
  showDialog('info');
}

const announcementAt = inject('announcement_at') as string;
const participateSuccessContent = computed(() => {
  const $announcementAt = dayjs(announcementAt);
  return `참여 신청이 완료되었습니다.
선정 결과는 ${$announcementAt.get('month') + 1}월 ${$announcementAt.get('date')}일
카카오톡 혹은 문자로 개별 안내 드릴 예정입니다.`;
});

const quizRef = ref<CampaignQuizExpose>();
const checkRef = ref<CampaignCheckExpose>();
const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
const participateEndedAt = inject('participate_ended_at') as string;
async function onStart() {
  const valid = await checkRef.value?.check();
  if (valid) {
    await refreshPageData();
    await nextTick();
    const { participation_request_id, show_participate_btn, participate_btn_msg, campaign_quiz } = props.program;
    if (show_participate_btn) {
      if (campaign_quiz) {
        quizRef.value?.startQuiz(campaign_quiz);
        return;
      }
      startParticipate();
      return;
    }

    // 不能参与
    const $now = dayjs();
    if ($now.isAfter(dayjs(participateEndedAt))) {
      if (participation_request_id) {
        const $announcementAt = dayjs(announcementAt);
        if ($now.isBefore($announcementAt)) {
          // 活动申请期已结束。结果将于 6 月 21 日单独公布。
          showInfoDialog({
            title: '',
            content: `캠페인 신청 기간이 종료되었습니다.
  결과는 ${$announcementAt.get('month') + 1}월 ${$announcementAt.get('date')}일 개별적으로 안내 드릴 예정입니다.`
          });
          return;
        }
      }
      // 活动申请期已结束。
      showInfoDialog({
        title: '',
        content: '캠페인 신청 기간이 종료되었습니다.'
      });
      return;
    }

    showInfoDialog({
      title: '',
      content: participate_btn_msg!,
    });
  }
}

function startParticipate() {
  showDialog('participate');
}

function showDialog(dialogName: keyof typeof dialog) {
  closeDialog();
  dialog[dialogName] = true;
}

function closeDialog(dialogName?: keyof typeof dialog) {
  if (dialogName) {
    dialog[dialogName] = false;
  } else {
    _.forEach(dialog, (val, key) => {
      if (val) {
        dialog[key] = false;
      }
    });
  }
}

const participateRef = ref<CampaignParticipateExpose>();
function participate() {
  closeDialog();
  participateRef.value?.participate({ collection_challenge: collectionChallenge.value, people_collection: 'individual' });
}

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(CampaignCheck, {
        ref_key: "checkRef",
        ref: checkRef,
        "class-name": "dialog-campaign-ssg"
      }, null, 512),
      _createVNode(CampaignQuiz, {
        ref_key: "quizRef",
        ref: quizRef,
        program: __props.program,
        "class-name": "dialog-campaign-ssg",
        onSuccess: startParticipate
      }, null, 8, ["program"]),
      _createVNode(CampaignParticipate, {
        ref_key: "participateRef",
        ref: participateRef,
        program: __props.program,
        "success-content": _unref(participateSuccessContent),
        "success-dialog-class-name": "dialog-campaign-ssg",
        "error-dialog-class-name": "dialog-campaign-ssg"
      }, null, 8, ["program", "success-content"]),
      _createVNode(_component_AppDialog, _mergeProps({
        visible: _unref(dialog).info,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).info) = $event)),
        class: "dialog-campaign-ssg dialog-campaign-info"
      }, infoDialogProps.value, {
        btns: [
        { text: '확인', style: _unref(ColorVariants).primary, click: () => closeDialog() }
      ]
      }), null, 16, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).participate,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).participate) = $event)),
        class: "dialog-campaign-ssg dialog-campaign-participate",
        btns: [
        { text: '확인', style: _unref(ColorVariants).primary, click: () => participate() }
      ]
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(radioOptions, (item) => {
              return _createElementVNode("div", {
                key: item.label,
                class: "radio-item"
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((collectionChallenge).value = $event)),
                  type: "radio",
                  value: item.value,
                  "data-checked": item.value === collectionChallenge.value,
                  name: "collectionChallenge"
                }, null, 8, _hoisted_3), [
                  [_vModelRadio, collectionChallenge.value]
                ]),
                _hoisted_4,
                _createElementVNode("label", null, _toDisplayString(item.label), 1)
              ])
            }), 64))
          ])
        ]),
        _: 1
      }, 8, ["visible", "btns"])
    ])),
    _createElementVNode("div", {
      class: "trigger",
      onClick: onStart
    }, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})